// バックエンドから取得予定のデータのモック
export const initialData = {
  inspections: [
    {
      name: 'Inspection 1',
      key: 'H1',
    },
    {
      name: 'Inspection 2',
      key: 'H2',
      value: '20',
    },
    {
      name: 'Inspection 3',
      key: 'H2_Bender',
      value: '30',
    },
    {
      name: 'Inspection 4',
      key: 'H2_Suspension',
      value: '40',
    },
    {
      name: 'Inspection 5',
      key: 'H3',
      value: '10',
    },
    {
      name: 'Inspection 6',
      key: 'H3_Bender',
      value: '20',
    },
    {
      name: 'Inspection 7',
      key: 'H3_Suspension',
      value: '30',
    },
    {
      name: 'Inspection 8',
      key: 'L1',
      value: '40',
    },
  ],
  otherInspections: [
    {
      name: 'Other Inspection 1',
      key: 'OtherInspection1',
      value: '0',
    },
    {
      name: 'Other Inspection 2',
      key: 'OtherInspection2',
    },
    {
      name: 'Other Inspection 3',
      key: 'OtherInspection3',
    },
  ],
};
export type InitialData = {
  inspections: {
    name: string;
    key: string;
    value?: string;
  }[];
  otherInspections: {
    name: string;
    key: string;
    value?: string;
  }[];
};
